import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {NavigationComponent} from './navigation/navigation.component';
import {PageModulesComponent} from './page-modules/page-modules.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent}, // inicio de sesion
  {path: 'modulos', component: PageModulesComponent}, // seleccion de modulo
  {
    path: 'procesadora',
    component: NavigationComponent,
    loadChildren: () => import('./_module/procesadora/procesadora.module').then(m => m.ProcesadoraModule)
  },
  {
    path: 'entidad',
    component: NavigationComponent,
    loadChildren: () => import('./_module/entidad/entidad.module').then(m => m.EntidadModule)
  },
  // {
  //   path: 'procesadora',
  //   component: NavigationComponent,
  //   children: [
  //     // {path: 'pais', },
  //     {path: 'sexo', children: routerSexo},
  //     {path: 'moneda', children: routerMoneda},
  //     {path: 'vivienda', children: routerVivienda},
  //     {path: 'legajos', children: routerLegajos},
  //     {path: 'departamento', children: routerDepartamento},
  //     {path: 'ciudad', children: routerCiudad},
  //     {path: 'barrio', children: routerBarrio},
  //     {path: 'aplicacion', children: routerAplicacion},
  //     {path: 'aplicacion_tipo', children: routerAplicacionTipo},
  //     {path: 'aplicacion_version', children: routerAplicacionVersion},
  //     {path: 'persona_documento_tipo', children: routerPersonaDocumentoTipo},
  //     {path: 'pais_feriado', children: routerPaisFeriado},
  //     {path: 'persona_imagen_tipo', children: routerPersonaImagenTipo},
  //     {path: 'direccion_tipo', children: routerDireccionTipo},
  //     {path: 'telefono_tipo', children: routerTelefonoTipo},
  //     {path: 'notificacion_tipo', children: routerNotificacionTipo},
  //     {path: 'entidad', children: routerEntidad},
  //     {path: 'entidad_tipo', children: routerEntidadTipo},
  //     {path: 'entidad_franquicia', children: routerEntidadFranquicia},
  //     {path: 'perfil_progreso', children: routerPerfilProgreso},
  //     // { path: 'maps', children: routerMaps },
  //
  //   ]
  //
  // },
  // {
  //   path: 'entidad',
  //   component: NavigationComponent,
  //   children: [
  //     {path: 'persona', children: routerPersona},
  //     {path: 'cliente', children: routerCliente},
  //     {path: 'solicitud_credito', children: routerSolicitudCredito},
  //     {path: 'graficos', children: routerGraficos},
  //   ]
  // },

  // {
  //   path: 'entidad',
  //   component: NavigationComponent,
  //   loadChildren: () => import('./_module/entidad/entidad.module').then(m => m.EntidadModule)
  // },

  {path: 'comercio', component: NavigationComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
